const livingWithInlaws = [
  { label: "Definitely consider", value: "Definitely consider" },
  { label: "May consider", value: "May consider" },
  { label: "Will not consider", value: "Will not consider" },
];
export default livingWithInlaws;
